import { Switch } from '@headlessui/react';
import * as React from 'react';
import { Link } from 'react-router-dom';
import * as z from 'zod';
import { Button } from '@/components/Elements';
import { Header } from '@/features/availability/components/Header';
import { SimpleHeader } from '@/features/availability/components/SimpleHeader';
import InputMask from 'react-input-mask';
import { useAuth } from '@/lib/auth';
import { ChangeEvent, useState } from 'react';
import Utils from '@/utils/util';
import { showNotification } from '@/utils/notificationUtils';

type RegisterValues = {
  firstName: string;
  lastName: string;
  email: string;
  password: string;
  teamId?: string;
  teamName?: string;
};

type RegisterFormProps = {
  onBackClick?: () => void;
  onSuccess?:()=>void;
  goToLogin?:()=>void;
};

export const Register = ({ onBackClick,onSuccess,goToLogin }: RegisterFormProps) => {
  const { register, isRegistering } = useAuth();
  const [email, setEmial] = useState('');
  const [phone, setPhone] = useState('');
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
    if (event.target.id === 'email') {
      setEmial(event.target.value);
    } else if (event.target.id === 'phone') {
      setPhone(event.target.value);
    }
    else if (event.target.id === 'password') {
      setPassword(event.target.value);
    }
    else if (event.target.id === 'confirmpassword') {
      setConfirmPassword(event.target.value);
    }
  };

  const validate = () => {
    if (!email || email.trim().length < 1 || !Utils.isValidEmail(email)) {
      showNotification({
        type: 'info',
        title: 'Please enter valid email',
      });
      return false;
    } 
    else if (!password) {
      showNotification({
        type: 'info',
        title: 'Please enter password',
      });
      return false;
    }
    else if (!confirmPassword||(password!=confirmPassword)) {
      showNotification({
        type: 'info',
        title: 'Password not matched',
      });
      return false;
    }
    else if (!phone || phone.trim().length < 1) {
      showNotification({
        type: 'info',
        title: 'Please enter valid phone number',
      });
      return false;
    } 
    return true;
  };

  return (
    <div className="full-height">
         <div className="top-cotent">
      {/* <Header
        onBackClick={() => {
          if(onBackClick)
          {
          onBackClick();
          }
        }}
      /> */}
      <SimpleHeader
        onBackClick={() => {
          if(onBackClick)
          {
          onBackClick();
          }
        }}
        screenTitle={"Sign Up"}
      />
      <div className="page-cotent-title"></div>
      <div className='signup-input-tab'>
      <div className="input-out-block">
        <input
          id="email"
          type="email"
          value={email}
          className="cust-input-mobile"
          onChange={handleChange}
          placeholder="Enter your email"
        />
      </div>
      <div className="input-out-block">
        <input
          id="password"
          type="password"
          value={password}
          className="cust-input-mobile"
          onChange={handleChange}
          placeholder="Enter your password"
        />
      </div>
      <div className="input-out-block">
        <input
          id="confirmpassword"
          type="password"
          value={confirmPassword}
          className="cust-input-mobile"
          onChange={handleChange}
          placeholder="Confirm password"
        />
      </div>
      <div className="input-out-block">
        <InputMask
          id="phone"
          placeholder="Phone number"
          className="cust-input-mobile"
          value={phone}
          mask="(999) 999-9999"
          onChange={handleChange}
        />
      </div>
      </div>
      <div>
        
      </div>
      <div className='terms-text'>
        <span>By continuing, you agree to our</span> <a href="">Terms of Service</a><span> and</span> <a href="">Privacy Policy</a>
      </div>
      <div className='already-login'>
        Already have an account? <a className="link" onClick={()=>{
          if (goToLogin) {
            goToLogin();
          }
        }}>Login</a>
      </div>
      </div>
      <div className='footer-btn-container'>
      <Button
        type="button"
        variant="primary"
        onClick={async()=>{
        

        }}
        className="w-full inline-flex justify-center rounded-md border profile-new-btn "
      >
        Continue
      </Button>
      </div>
    </div>
  );
};
